import PropTypes from 'prop-types';

import Icon from 'shopper/components/Icon';
import Text from 'shopper/components/Text';

const ChecklistItem = ({ children, checked }) => (
  <Text
    className="flex min-w-max items-center gap-x-2 text-neutral-low-200 dark:text-neutral-high-400"
    size="size2"
  >
    <Icon
      className="text-neutral-low-200 dark:text-neutral-high-400"
      name={checked ? 'check' : 'close'}
      size="size2"
    />
    {children}
  </Text>
);

ChecklistItem.propTypes = {
  checked: PropTypes.bool.isRequired,
  children: PropTypes.node.isRequired,
};

export default ChecklistItem;
